import { GET_DASHBOARD_LIST_FAILED } from "dashboard/actions/list";
import { GET_ITEM_FAILED } from "actions/items";

// For errors that won't be caught by ErrorBoundary (because they are async)
// Updates error message to notify about the failed actions
export default function(state = null, action) {
  switch (action.type) {
    case GET_DASHBOARD_LIST_FAILED:
    case GET_ITEM_FAILED:
      return action.payload;
    default:
      return state;
  }
}
